import { Component, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { CommonService } from 'src/app/services/common.service';
import { UiSpinnerService } from 'src/app/services/ui-spinner.service';
import { localStorageConstants } from 'src/consts/local-storage-constants';

import { sweetAlert } from 'src/consts/sweet_alert';
import { gallery_options, showNotification, swalWithBootstrapButtons, commonLocalThumbImage, commonNetworkThumbImage, commonNetworkAttachmentViewer, longDate, logobase64, EST_FULL_DATE_TIME } from 'src/consts/utils';
import { configData } from 'src/environments/configData';
import { DeviceDetectorService } from 'ngx-device-detector';


import { SeoService } from 'src/app/seo.service';
import { ClientModel, RolePermission } from 'src/app/superadmin/superadmin.model';

import * as pdfMake from 'pdfmake/build/pdfmake';

import { icon } from 'src/consts/icon';
import { HttpCall } from 'src/app/services/httpcall.service';
import { NgxGalleryComponent, NgxGalleryOptions, NgxGalleryImage } from 'ngx-gallery-15';
import { PortalTicketModel } from '../../common-components.model';
import { httpVersion, httpRoutes, superAdminRoutes } from 'src/consts/http-routes';
import { WEB_ROUTES } from 'src/consts/routes';
import { wasabiImagePath } from 'src/consts/wasabiImagePath';

@Component({
  selector: 'app-portal-ticket-form',
  templateUrl: './portal-ticket-form.component.html',
  styleUrls: ['./portal-ticket-form.component.scss'],
  standalone: false
})

export class PortalTicketFormComponent {
  @ViewChild('OpenFilebox') OpenFilebox: any;
  filepath: any;
  ticketform!: UntypedFormGroup;
  hide = true;
  agree = false;
  id: any;
  isDelete = 1;
  files_old: string[] = [];
  last_files_array: string[] = [];
  files: File[] = [];
  @ViewChild('gallery') gallery!: NgxGalleryComponent;
  galleryOptions!: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[] = [];
  imageObject = [];
  tmp_gallery: any;
  submitting_text = '';
  titleMessage = "";
  show = false;
  is_delete: any;
  variablescompanylist: Array<ClientModel> = [];
  public companylist = this.variablescompanylist.slice();
  ticket_prefix: any;
  tool_list: Array<any> = [];
  ticket_Form_Submitting = "";
  ticketData: any;
  company_code: any;
  companyData: any;
  user_name = "";
  created_for: any;
  role_permission!: RolePermission;
  public variablesuserlist: Array<PortalTicketModel> = [];
  public companyUserList = this.variablesuserlist.slice();
  public status_ticket: any = configData.TICKET_STATUS;
  public priority: any = configData.TICKET_PRIORITY;
  public prefix: any = configData.TICKET_PRIFIX[0];
  deviceInfo: any;
  lookupInfo: any;
  new_reqObject: any;
  old_location_name: any = "";
  userdata: any;
  smartaccupay_logo: any = icon.INVOICE_LOGO
    ;

  constructor(
    private seo: SeoService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private snackBar: MatSnackBar,
    public uiSpinner: UiSpinnerService,
    public translate: TranslateService,
    public route: ActivatedRoute,
    private sanitiser: DomSanitizer,
    public commonService: CommonService,
    private formBuilder: FormBuilder,
    private deviceService: DeviceDetectorService,
    private httpCall: HttpCall,
  ) {

    this.id = this.route.snapshot.queryParamMap.get('_id') ?? '';

    this.role_permission = JSON.parse(localStorage.getItem(localStorageConstants.USERDATA)!)?.role_permission;
    this.userdata = localStorage.getItem(localStorageConstants.USERDATA) as string;
    this.userdata = JSON.parse(this.userdata);


    this.seo.setTags({
      title: 'Portal Ticket Form', // Title
      titleSuffix: '- SmartAccuPay', // Title Suffix
      description: 'SmartAccuPay portal ticket form', // Description
      image: '', // Image
      keywords: 'SmartAccuPay' // Keywords
    });

    // Initialize ticketform here
    this.ticketform = this.formBuilder.group({
      company_name: [""],
      user_name: [""],
      email: [""],
      phone: [""],
      status: [""],
      priority: [""],
      ticket_prefix: [""],
      ticket_title: [""],
      ticket_description: [""],
    });



    // Subscribe to value changes and update the first character
    if (this.ticketform) {
      this.ticketform.get('ticket_title')?.valueChanges.subscribe(value => {
        if (value) {
          this.ticketform.patchValue({
            ticket_title: value.charAt(0).toUpperCase() + value.slice(1),
          }, { emitEvent: false });
        }
      });


      this.ticketform.get('ticket_description')?.valueChanges.subscribe(value => {
        if (value) {
          this.ticketform.patchValue({
            ticket_description: value.charAt(0).toUpperCase() + value.slice(1),
          }, { emitEvent: false });
        }
      });
    }


    this.epicFunction();
    this.getAllCompany();
    if (this.id) {
      this.getOneTicket();
    }
  }
  ngOnInit(): void {
    this.getAllCompany();


    this.ticketform.get("user_name")!.setValue(this.userdata.UserData.userfullname);
    this.ticketform.get("email")!.setValue(this.userdata.UserData.useremail);
    this.ticketform.get("phone")!.setValue(this.userdata.companydata.companyphone);
    this.ticketform.get("company_name")!.setValue(this.userdata.companydata.companyname);

    // Check if ticket_prefix control exists in ticketform
    if (this.ticketform && this.ticketform.get('ticket_prefix')) {
      // Set the value of ticket_prefix
      this.ticketform.get('ticket_prefix')!.setValue('SmartAccuPay');
    } else {
      console.error('ticketform or ticket_prefix control not found.');
    }
    this.tmp_gallery = gallery_options();
    this.tmp_gallery.actions = [
      {
        icon: 'fas fa-download',
        onClick: this.downloadButtonPress.bind(this),
        titleText: 'download',
      },
    ];
    this.galleryOptions = [this.tmp_gallery];

  }

  epicFunction() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
  }


  async getOneTicket() {
    let that = this;
    const data = await this.commonService.postRequestAPI(httpVersion.PORTAL_V1 + httpRoutes.GET_ONE_TICKET_PORTAL, { _id: this.id });
    if (data.status) {
      that.ticketData = data.getoneticket;
      that.created_for = that.ticketData.created_for;
      that.files_old = [];
      for (
        let loop_i = 0;
        loop_i < that.ticketData.attachment.length;
        loop_i++
      ) {
        that.files_old.push(that.ticketData.attachment[loop_i]);
      }
      that.last_files_array = that.ticketData.attachment;

      that.ticketform = that.formBuilder.group({
        company_name: [that.ticketData.company_name.companyname, Validators.required],
        user_name: [that.ticketData.user_name],
        ticket_prefix: [that.ticketData.portal_key],
        email: [that.ticketData.email],
        phone: [that.ticketData.phone],
        portal_key: [that.ticketData.portal_key],
        ticket_title: [that.ticketData.ticket_title, Validators.required],
        ticket_description: [
          that.ticketData.ticket_description,
          Validators.required,
        ],
      });
    }

  }


  async getAllCompany() {
    const data = await this.commonService.getRequestAPI(httpVersion.SUPERADMIN_V1 + superAdminRoutes.TICKET_GET_ALL_COMPANY);
    if (data.status) {
      this.variablescompanylist = data.data;
      this.companylist = this.variablescompanylist.slice();
      if (this.id != null) {
        this.getOneTicket();
      }
    }
  }


  capitalizeFirstLetter(str: string): string {
    return str.split(' ').map(word => word[0].toUpperCase() + word.substring(1)).join(' ');
  }
  private getBase64ImageFromURL(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      let img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
      img.onload = () => {
        let canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        let ctx = canvas.getContext("2d");
        ctx!.drawImage(img, 0, 0);
        let dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
      img.onerror = error => reject(error);
      img.src = url;
    });
  }
  //pdf code
  async generatePdf() {

    const documentDefinition: any = await this.getDocumentDefinition(this.ticketData);
    const pdf = pdfMake!.createPdf(documentDefinition).download();
  }

  async getDocumentDefinition(data: any) {
    const smartAccuPayLogo = await logobase64();
    let noteTable = {};
    if (data.length != 0) {

      const noteData = [];
      if (data.charts != 0) {
        for (let i = 0; i < data.charts.length; i++) {
          noteData.push(
            [
              { text: `Create By`, bold: true, fontSize: 10, alignment: 'center', },
              { text: `Create At`, bold: true, fontSize: 10, alignment: 'center', },
            ],
            [
              { text: `${data.created_for_user.userfullname}`, fontSize: 10, alignment: 'left', },
              { text: EST_FULL_DATE_TIME(`${data.charts[i].create_date}`, "en"), fontSize: 10, alignment: 'left', },
            ],
            [{ text: `Note`, bold: true, fontSize: 10, alignment: 'left', colSpan: 2 },],
            [{ text: `${data.charts[i].message}`, fontSize: 10, alignment: 'left', colSpan: 2 },]
          );
        }
        noteTable = {
          style: 'tableHeader',
          margin: [0, 10, 0, 0],
          table: {
            widths: ['*', '*'],
            body: noteData
          },
          layout: {
            // hLineColor: function (i, node) {
            //   return 'grey';
            // },
            // vLineColor: function (i, node) {
            //   return 'grey';
            // }
          }
        };
      }
    }
    return {
      footer: function (currentPage: any, pageCount: any) {
        return [
          {
            columns: [
              {
                table: {
                  widths: ['*', '*', '*'],
                  body: [
                    [
                      { text: ``, fontSize: 10, alignment: 'left', margin: [35, 0, 0, 0] },
                      { text: currentPage.toString() + ' of ' + pageCount, fontSize: 10, alignment: 'center', margin: [0, 0, 0, 0] },
                      {
                        alignment: 'right',
                        table: {
                          widths: ['*', 55],
                          body: [
                            [
                              { text: 'Powered by ', fontSize: 9, alignment: 'left', margin: [60, 0, 0, 0] },
                              { image: `data:image/png;base64,${smartAccuPayLogo}`, width: 55, alignment: 'right', margin: [0, 0, 15, 0] },
                            ],
                          ]
                        },
                        layout: 'noBorders'
                      },
                    ],
                  ]
                },
                layout: 'noBorders'
              },
            ]
          }
        ];
      },
      pageMargins: [35, 50, 35, 50],
      pageSize: 'LETTER',
      content: [
        {
          style: 'tableHeader',
          margin: [0, 10, 0, 0],
          table: {
            widths: ['*'],
            body: [[{ text: `Ticket Information`, color: 'white', border: [false, false, false, false], alignment: 'center', bold: true, margin: [0, 4] },],]
          },
          layout: {
            fillColor: function (rowIndex: any, node: any, columnIndex: any) {
              return (rowIndex % 2 === 0) ? '#023E8A' : null;
            }
          }
        },
        {
          border: [false, false, false, false],
          margin: [0, 10, 0, 0],
          table: {
            widths: ['*'],
            body: [
              [
                {
                  table: {
                    widths: ['*'],
                    body: [
                      [
                        // common.pdfTableImageWidth(`${companyLogo}`, 80),
                        // 'Logo',
                        {
                          table: {
                            widths: ['50%', '*'],
                            body: [
                              [
                                { text: "Ticket Title", color: 'gray', fontSize: 10, alignment: 'left', },
                                { text: `${data.ticket_title}`, color: 'black', alignment: 'left', bold: false, fontSize: 10, margin: [0, 0] }
                              ],
                              [
                                { text: "Ticket Description", color: 'gray', fontSize: 10, alignment: 'left', },
                                { text: `${data.ticket_description}`, color: 'black', alignment: 'left', bold: false, fontSize: 10, margin: [0, 0] }
                              ],
                              [
                                { text: "User Name", color: 'gray', fontSize: 10, alignment: 'left', },
                                { text: `${data.user_name}`, color: 'black', alignment: 'left', bold: false, fontSize: 10, margin: [0, 0] }
                              ],
                              [
                                { text: "Email", color: 'gray', fontSize: 10, alignment: 'left', },
                                { text: `${data.email}`, color: 'black', alignment: 'left', bold: false, fontSize: 10, margin: [0, 0] }
                              ],
                              [
                                { text: "Phone", color: 'gray', fontSize: 10, alignment: 'left', },
                                { text: `${data.phone}`, color: 'black', alignment: 'left', bold: false, fontSize: 10, margin: [0, 0] }
                              ],
                              [
                                { text: "Status", color: 'gray', fontSize: 10, alignment: 'left', },
                                { text: `${data.status}`, color: 'black', alignment: 'left', bold: false, fontSize: 10, margin: [0, 0] }
                              ],
                              [
                                { text: "Priority", color: 'gray', fontSize: 10, alignment: 'left', },
                                { text: `${data.priority}`, color: 'black', alignment: 'left', bold: false, fontSize: 10, margin: [0, 0] }
                              ],
                            ]
                          },

                        },
                      ]
                    ]
                  },
                  layout: 'noBorders'
                },
              ]
            ]
          },
          layout: 'noBorders'

        },
        {
          style: 'tableHeader',
          margin: [0, 10, 0, 0],
          table: {
            widths: ['*'],
            body: [[{ text: `Device Information`, color: 'white', border: [false, false, false, false], alignment: 'center', bold: true, margin: [0, 4] },],]
          },
          layout: {
            fillColor: function (rowIndex: any, node: any, columnIndex: any) {
              return (rowIndex % 2 === 0) ? '#023E8A' : null;
            }
          }
        },
        {
          border: [false, false, false, false],
          margin: [0, 10, 0, 0],
          table: {
            widths: ['*'],
            body: [
              [
                {
                  table: {
                    widths: ['*'],
                    body: [
                      [
                        // common.pdfTableImageWidth(`${companyLogo}`, 80),


                        {
                          table: {
                            widths: ['50%', '*'],
                            body: [
                              [
                                { text: "UUID", color: 'gray', fontSize: 10, alignment: 'left', },
                                { text: `${data.UUID}`, color: 'black', alignment: 'left', bold: false, fontSize: 10, margin: [0, 0] }
                              ],
                              [
                                { text: "Browser", color: 'gray', fontSize: 10, alignment: 'left', },
                                { text: `${data.browser}`, color: 'black', alignment: 'left', bold: false, fontSize: 10, margin: [0, 0] }
                              ],
                              [
                                { text: "Browser Version", color: 'gray', fontSize: 10, alignment: 'left', },
                                { text: `${data.browser_version}`, color: 'black', alignment: 'left', bold: false, fontSize: 10, margin: [0, 0] }
                              ],
                              [
                                { text: "Devices", color: 'gray', fontSize: 10, alignment: 'left', },
                                { text: `${data.devices}`, color: 'black', alignment: 'left', bold: false, fontSize: 10, margin: [0, 0] }
                              ],
                              [
                                { text: "Device Name", color: 'gray', fontSize: 10, alignment: 'left', },
                                { text: `${data.devices_name}`, color: 'black', alignment: 'left', bold: false, fontSize: 10, margin: [0, 0] }
                              ],
                              [
                                { text: "IP Address", color: 'gray', fontSize: 10, alignment: 'left', },
                                { text: `${data.ip_address}`, color: 'black', alignment: 'left', bold: false, fontSize: 10, margin: [0, 0] }
                              ],
                              [
                                { text: "Location", color: 'gray', fontSize: 10, alignment: 'left', },
                                { text: `${data.location}`, color: 'black', alignment: 'left', bold: false, fontSize: 10, margin: [0, 0] }
                              ],
                              [
                                { text: "OS", color: 'gray', fontSize: 10, alignment: 'left', },
                                { text: `${data.os}`, color: 'black', alignment: 'left', bold: false, fontSize: 10, margin: [0, 0] }
                              ],
                              [
                                { text: "OS Version", color: 'gray', fontSize: 10, alignment: 'left', },
                                { text: `${data.os_version}`, color: 'black', alignment: 'left', bold: false, fontSize: 10, margin: [0, 0] }
                              ],
                            ]
                          },
                          // layout: 'noBorders'
                        },
                      ]
                    ]
                  },
                  layout: 'noBorders'
                },
              ]
            ]
          },
          layout: 'noBorders'

        },
        {
          style: 'tableHeader',
          margin: [0, 10, 0, 0],
          table: {
            widths: ['*'],
            body: [[{ text: `Notes`, color: 'white', border: [false, false, false, false], alignment: 'center', bold: true, margin: [0, 4] },],]
          },
          layout: {
            fillColor: function (rowIndex: any, node: any, columnIndex: any) {
              return (rowIndex % 2 === 0) ? '#023E8A' : null;
            }
          }
        },
        noteTable


      ],
    };
  }

  async portalSaveTicket() {
    this.new_reqObject = {
      created_date: longDate(new Date()),
      ip_address: '',
      mac_address: "",
      device_type: "Web",
      device_name: this.deviceInfo["device"] + " " + this.deviceInfo["deviceType"],
      os: this.deviceInfo["os"],
      os_version: this.deviceInfo["os_version"],
      browser: this.deviceInfo["browser"],
      browser_version: this.deviceInfo["browser_version"],
      location: '',
      location_lat: '',
      location_lng: '',
      companycode: this.userdata.companydata.companycode,
    };

    fetch("https://ipinfo.io/json?token=c22c8f2cf5a2b9")
      .then((res) => res.json())
      .then((response) => {
        this.lookupInfo = response;
        let loc = this.lookupInfo["loc"];
        let let_log = loc.split(",");
        this.new_reqObject.ip_address = this.lookupInfo["ip"];
        this.new_reqObject.location = this.lookupInfo["city"] + ", " + this.lookupInfo["country"] + ", " + this.lookupInfo["postal"];
        this.new_reqObject.location_lat = let_log[0];
        this.new_reqObject.location_lng = let_log[1];
      })
      .catch(() => { });

    if (this.ticketform.valid) {
      let attachmentData = [];
      this.uiSpinner.spin$.next(true);
      // Check if there are any files to upload
      if (this.files && this.files.length > 0) {

        for (let i = 0; i < this.files.length; i++) {
          const formData = new FormData();
          formData.append("file", this.files[i]);
          formData.append("dir_name", wasabiImagePath.TICKET_ATTACHMENT);
          const params = await this.commonService.postRequestAPI(httpVersion.PORTAL_V1 + httpRoutes.PORTAL_SAVE_ATTACHMENT, formData);
          if (params.status) {
            attachmentData.push(params.data[0]);
          } else {
            showNotification(this.snackBar, params.message, 'error');
            this.uiSpinner.spin$.next(false);
            return; // Exit if attachment upload fails
          }
        }
      }

      // Continue processing the ticket form
      const reqObject = this.ticketform.value;
      reqObject.ticket_prefix = this.prefix.prefix;
      reqObject.portal_key = this.prefix.value;
      reqObject.company_code = this.userdata.companydata.companycode;
      reqObject.company_name = this.userdata.companydata._id;
      reqObject.location = this.new_reqObject.location;
      reqObject.devices_name = this.new_reqObject.device_name;
      reqObject.os = this.new_reqObject.os;
      reqObject.os_version = this.new_reqObject.os_version;
      reqObject.browser = this.new_reqObject.browser;
      reqObject.browser_version = this.new_reqObject.browser_version;
      reqObject.ip_address = this.new_reqObject.ip_address;
      reqObject.UUID = "";
      reqObject.devices = this.deviceInfo.device;

      if (this.id) {
        reqObject._id = this.id;
        reqObject.created_for = this.created_for;
        reqObject.attachment = attachmentData.concat(this.last_files_array || []);
        reqObject.old_location_name = this.old_location_name;
      } else {
        if (attachmentData.length > 0) {
          reqObject.attachment = attachmentData;
        }
      }

      const params_new = await this.commonService.postRequestAPI(httpVersion.PORTAL_V1 + httpRoutes.SAVE_PORTAL_TICKET, reqObject);
      if (params_new.status) {
        showNotification(this.snackBar, params_new.message, 'success');
        this.router.navigateByUrl("ticket-list");
      } else {
        showNotification(this.snackBar, params_new.message, 'error');
      }

      this.uiSpinner.spin$.next(false);
    } else {
      showNotification(this.snackBar, this.ticket_Form_Submitting, 'error');
    }
  }

  confirmExit() {
    if (this.ticketform.dirty) {
      swalWithBootstrapButtons
        .fire({
          title: this.translate.instant('VENDOR.CONFIRMATION_DIALOG.SAVING'),
          imageUrl: this.smartaccupay_logo,
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: this.translate.instant('COMMON.ACTIONS.SAVE_EXIT'),
          cancelButtonText: this.translate.instant('COMMON.ACTIONS.DO_NOT_SAVE'),
          denyButtonText: this.translate.instant('COMMON.ACTIONS.CANCEL'),
          allowOutsideClick: false,
          background: localStorage.getItem(localStorageConstants.DARKMODE) === 'dark' ? sweetAlert.DARK_BACKGROUND : sweetAlert.WHITE_BACKGROUND,
          color: localStorage.getItem(localStorageConstants.DARKMODE) === 'dark' ? sweetAlert.DARK_COLOR : sweetAlert.WHITE_COLOR,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.submitting_text = this.translate.instant(
              'VENDOR.CONFIRMATION_DIALOG.SUBMIT'
            );
            // Move to the vendor listing
            if (this.ticketform.valid) {
              this.portalSaveTicket();
            } else {
              // alert form invalidation
              showNotification(this.snackBar, this.submitting_text, 'error');
            }
          } else if (result.isDenied) {
            // ;
          } else {
            setTimeout(() => {

              this.router.navigate([WEB_ROUTES.TICKET_LIST]);

            }, 100);
          }
        });
    }
    else {
      this.back();
    }
  }

  back() {
    this.router.navigate([WEB_ROUTES.TICKET_LIST]);
  }


  onFileDropped($event: any) {
    this.prepareFilesList($event);
  }
  fileChange(event: Event) {
    const element = event.currentTarget as HTMLInputElement;
    const fileList = element.files;
    if (fileList) {
      this.prepareFilesList(fileList);
    }
  }

  fileBrowseHandler(files: any) {
    this.prepareFilesList(files);
  }

  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  deleteFile_old(index: number) {
    this.last_files_array.splice(index, 1);
    this.files_old.splice(index, 1);
  }

  prepareFilesList(files: any) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
  }

  // View Thumbnail of Location attachment
  thumbImage(file: File) {
    return commonLocalThumbImage(this.sanitiser, file);
  }

  // View Thumbnail of Network Attachment
  thumbNetworkImage(index: number) {
    return commonNetworkThumbImage(this.last_files_array[index]);
  }

  imageNetworkPreview(allAttachment: Array<string>, index: number) {
    this.galleryImages = commonNetworkAttachmentViewer(allAttachment);
    setTimeout(() => {
      this.gallery.openPreview(index);
    }, 0);
  }

  downloadButtonPress(event: any, index: number): void {
    window.location.href = this.last_files_array[index];
  }

  openfilebox() {
    const el: HTMLElement = this.OpenFilebox.nativeElement;
    el.click();
  }

  getName(name: any) {
    console.log("name", name);
    let nameSplit = name.split("?");
    return nameSplit[0];
  }

}